export const allowedFiles = [
    'docx',
    'pdf',
    'html',
    'tiff',
    '3pg',
    'mp4',
    'doc',
    'xls',
    'ppt',
    'xlsx',
    'pptx',
    'odt',
    'ods',
    'odp',
    'png',
    'bmp',
    'jpg',
    'jpeg',
];

export const STORE_FILTYPER = ['pdf', 'png', 'jpg', 'jpeg', 'doc', 'docx', 'bmp'];
